import React, { useEffect, useRef, useState } from 'react'
import { Card, Table, Input, Button, Modal, Row, Col, Form, Upload, message } from 'antd';
import { DeleteOutlined, SearchOutlined, UploadOutlined, CloudDownloadOutlined, CloudUploadOutlined, DownloadOutlined, FileExcelOutlined, CheckCircleFilled, ContactsOutlined, PhoneOutlined, MailOutlined, LockOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Flex from 'components/shared-components/Flex'
import { useParams } from "react-router-dom";
import utils from 'utils'
import { useMyContext } from 'Context/MyContextProvider';
import apiClient from 'services/apiClient';
import * as XLSX from 'xlsx';
import { ALERTBG, PRIMARY_BORDER, PRIMARY } from '../CustomUtils.js/utils';
import { CustomAlertBanner } from '../components/AlertBadge';
import { Users } from 'lucide-react';

const { confirm } = Modal;


const ContactList = () => {
    const { api, authToken, HandleExport } = useMyContext();

    const [isDragging, setIsDragging] = useState(false)
    const dragCounter = useRef(0)
    const [ContactList, setContactList] = useState([])
    const [contactListData, setContactListData] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [importedData, setImportedData] = useState([])
    const [fileList, setFileList] = useState([])
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')

    const [contactName, setContactName] = useState('')
    const [number, setNumber] = useState('')
    const [email, setEmail] = useState('')
    const [location, setLocation] = useState('')
    const { id } = useParams();
    const addContactRef = useRef();
    const resetImport = useRef();
    const GroupData = async () => {
        try {
            const response = await apiClient.get(`${api}edit-group/${id}`, {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            });
            // console.log(response.data.groups.contacts)
            setName(response.data.groups.name);
            setDescription(response.data.groups.description);
            setDescription(response.data.groups.description);
            const data = (response.data.groups.contacts).reverse();
            setContactList(data);
            setContactListData(data);

        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        GroupData()
    }, [])

    useEffect(() => {
        if (resetImport.current) {
            resetImport.current.setFieldsValue({
                "Choose File": fileList.length > 0 ? fileList : null
            });
        }
    }, [fileList]);




    const tableColumns = [
        {
            title: 'Name',
            dataIndex: 'name'
        },
        {
            title: 'Mobile Number',
            dataIndex: 'number',
            sorter: (a, b) => utils.antdTableSorter(a, b, 'number')
        },
        {
            title: 'Email ID',
            dataIndex: 'email',
            sorter: (a, b) => utils.antdTableSorter(a, b, 'email')
        },
        {
            title: 'Location',
            dataIndex: 'location',
            sorter: (a, b) => utils.antdTableSorter(a, b, 'location')
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            render: (_, item) => (
                <Flex alignItems="center" style={{ gap: '1rem' }}>
                    <span className='d-flex h4 cursor-pointer' onClick={() => showConfirm(item.id)}>
                        <DeleteOutlined />
                    </span>
                </Flex>
            )
        }
    ];


    function showConfirm(id) {
        confirm({
            title: 'Do you Want to delete this contact?',
            content: "By deleting the contact, it will be permanently removed from the system and can't be restored.",
            onOk() {
                HandleDeleteContact(id)
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    function showConfirmForMulti() {
        confirm({
            title: 'Do you Want to delete these contacts?',
            content: "By deleting the contacts, it will be permanently removed from the system and can't be restored.",
            onOk() {
                HandleMultiDelete()
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const rowSelection = {
        onChange: (key, rows) => {
            setSelectedRowKeys(key)
        }
    };

    const onSearch = e => {
        const value = e.currentTarget.value
        const searchArray = e.currentTarget.value ? ContactList : contactListData
        const data = utils.wildCardSearch(searchArray, value)
        setContactList(data)
        setSelectedRowKeys([])
    }


    const props = {
        onRemove: file => {
            setFileList([]);
            setImportedData([]);
        },
        beforeUpload: file => {
            setImportedData([])
            const reader = new FileReader();
            const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.name.endsWith('.xlsx');
            if (!isExcel) {
                message.error('You can only upload Excel files (.xlsx)!');
                setFileList([]);
                return false;
            }
            setFileList([file]);
            reader.onload = (event) => {
                const binaryString = event.target.result;
                const workbook = XLSX.read(binaryString, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                const filteredData = jsonData.slice(1).filter(row => row.length > 0);
                // console.log(filteredData);
                setImportedData(filteredData);
            };

            reader.readAsBinaryString(file);
            return false;
        },
        onChange: info => {
            if (info.fileList) {
                setFileList(info.fileList.slice(-1));
            }
        },
        fileList
    };

    const HandleImport = async () => {
        // console.log(importedData)
        // return
        try {
            const response = await apiClient.post(`${api}import-group/${id}`, { importedData }, {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            });

            if (response.data.status) {
                GroupData();
                resetImport.current.resetFields();
                setFileList([]);
                setImportedData([]);
            }
        } catch (error) {
            // setConfirmLoading(false);
            // handleCancel()
            console.log(error);
        }
    }
    const HandleDeleteContact = async (deleteid) => {

        try {
            const response = await apiClient.delete(`${api}delete-contact/${deleteid}`, {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            });
            console.log(response);
            if (response.data.status) {
                GroupData();
            }
        } catch (error) {
            // setConfirmLoading(false);
            // handleCancel()
            console.log(error);
        }
    }
    const HandleMultiDelete = async () => {
        try {
            const response = await apiClient.delete(`${api}multi-delete-contacts`, {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
                data: {
                    ids: selectedRowKeys
                }
            });
            console.log(response);
            if (response.data.status) {
                GroupData();
            }
        } catch (error) {
            console.log(error);
        }
    }

    const HandleSubmit = async () => {
        try {
            const response = await apiClient.post(`${api}create-contact/${id}`, { group_id: id, number, name: contactName, email: email, location: location }, {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            });
            console.log(response);
            if (response.data.status) {

                GroupData();
                addContactRef.current.resetFields();
            }
        } catch (error) {
            console.log(error);
        }
    }

    const downloadSampleExcel = () => {
        const rows = [
            ["John Doe", "919876543210", "john.doe@example.com", "New York"],
            ["Jane Smith", "919876543211", "jane.smith@example.com", "London"]
        ];

        const ws = XLSX.utils.aoa_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Contacts");
        XLSX.writeFile(wb, "sample_group.xlsx");
    };

    const getImportStats = () => {
        if (!importedData || importedData.length === 0) return null;

        const total = importedData.length;
        const numbers = importedData.map(row => String(row[1] || '').trim()).filter(Boolean);
        const emails = importedData.map(row => String(row[2] || '').trim().toLowerCase()).filter(Boolean);

        const uniqueNumbers = new Set(numbers);
        const duplicateNumbersCount = numbers.length - uniqueNumbers.size;

        const uniqueEmails = new Set(emails);
        const duplicateEmailsCount = emails.length - uniqueEmails.size;

        return {
            total,
            duplicateNumbers: duplicateNumbersCount,
            duplicateEmails: duplicateEmailsCount,
        };
    };

    const stats = getImportStats();

    return (
        <>
            <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={12}>
                    <Row gutter={24}>
                        {/* group detais */}
                        <Col xs={24} sm={24} md={24} lg={24}>
                            <Card title="Edit Group Detail">
                                <Row>
                                    <Col span={24}>
                                        <Form
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 10 }}
                                            layout="horizontal"
                                        >
                                            <Form.Item label="Group Name" className=" my-3">
                                                <Input type="text"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    placeholder="Group Name"
                                                />
                                            </Form.Item>
                                            <Form.Item label="Group Description" className=" my-3">
                                                <Input type="text"
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    placeholder="Group Description"
                                                />
                                            </Form.Item>
                                            <Form.Item label=" " className=" my-3">
                                                <Button type="primary">Update</Button>
                                            </Form.Item>

                                        </Form>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        {/* contact list  */}
                        <Col xs={24} sm={24} md={24} lg={24}>
                            <Card title="Contacts">
                                <Flex alignItems="center" justifyContent="space-between" mobileFlex={false}>
                                    <Flex className="mb-1" mobileFlex={false}>
                                        <div className="mr-md-3 mb-3">
                                            <Input placeholder="Search" prefix={<SearchOutlined />} onChange={e => onSearch(e)} />
                                        </div>
                                        {selectedRowKeys?.length > 0 &&
                                            <div className="mr-md-3 mb-3 d-flex align-items-center border rounded px-2 py-1 cursor-pointer" onClick={() => showConfirmForMulti()}>
                                                <span className='h4 m-0'><DeleteOutlined /></span>
                                            </div>
                                        }

                                    </Flex>
                                    <div className="mb-3 text-right">
                                        <Button icon={<CloudDownloadOutlined />} onClick={() => HandleExport('export-group-contacts', name + '_contacts.xlsx', id)}>Export Contacts</Button>
                                    </div>
                                </Flex>
                                <div className="table-responsive">
                                    <Table
                                        columns={tableColumns}
                                        dataSource={ContactList}
                                        rowKey='id'
                                        rowSelection={{
                                            selectedRowKeys: selectedRowKeys,
                                            type: 'checkbox',
                                            preserveSelectedRowKeys: false,
                                            ...rowSelection,
                                        }}
                                    />
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Col>

                {/* new or update contact  */}
                <Col xs={24} sm={24} md={24} lg={12}>
                    <Row gutter={24}>
                        {/* import  */}
                        <Col xs={24} sm={24} md={24} lg={24}>
                            <Card>
                                <div className="d-flex align-items-center mb-4">
                                    <div style={{
                                        width: '44px',
                                        height: '44px',
                                        borderRadius: '12px',
                                        backgroundColor: ALERTBG,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '12px',
                                        border: `1px solid ${PRIMARY_BORDER}`
                                    }}>
                                        <CloudUploadOutlined style={{ fontSize: '20px', color: PRIMARY }} />
                                    </div>
                                    <div>
                                        <h3 style={{ margin: 0, fontWeight: 700, color: '#092b00', fontSize: '18px' }}>Import Contact</h3>
                                        <p style={{ color: '#8c8c8c', fontSize: '13px', margin: 0 }}>Upload an Excel file to import contacts to this group.</p>
                                    </div>
                                </div>
                                <Form
                                    layout="vertical"
                                    ref={resetImport}
                                    onFinish={HandleImport}
                                >
                                    <Row gutter={24}>
                                        <Col xs={24} md={16}>
                                            <Form.Item
                                                name="Choose File"
                                                rules={[{ required: true, message: 'Please select your file!' }]}
                                                style={{ marginBottom: '16px' }}
                                            >
                                                <div
                                                    onDragEnter={(e) => {
                                                        e.preventDefault();
                                                        dragCounter.current++;
                                                        if (dragCounter.current === 1) setIsDragging(true);
                                                    }}
                                                    onDragLeave={(e) => {
                                                        e.preventDefault();
                                                        dragCounter.current--;
                                                        if (dragCounter.current === 0) setIsDragging(false);
                                                    }}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    onDrop={(e) => {
                                                        dragCounter.current = 0;
                                                        setIsDragging(false);
                                                    }}
                                                    style={{
                                                        borderRadius: '10px',
                                                        border: isDragging || fileList.length > 0
                                                            ? `2px dashed ${PRIMARY_BORDER}`
                                                            : '1.5px solid #e8e8e8',
                                                        backgroundColor: isDragging || fileList.length > 0
                                                            ? ALERTBG
                                                            : '#ffffff',
                                                        transition: 'all 0.25s ease',
                                                        overflow: 'hidden',
                                                    }}
                                                >
                                                    <Upload.Dragger
                                                        {...props}
                                                        accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                        maxCount={1}
                                                        showUploadList={false}
                                                        style={{ border: 'none', background: 'transparent', borderRadius: '10px' }}
                                                    >
                                                        <p className="ant-upload-drag-icon" style={{ marginBottom: '12px' }}>
                                                            <CloudUploadOutlined style={{
                                                                fontSize: '40px',
                                                                display: 'inline-block',
                                                                transform: isDragging ? 'translateY(-5px) scale(1.1)' : 'translateY(0) scale(1)',
                                                                transition: 'transform 0.25s ease',
                                                            }} />
                                                        </p>
                                                        <p style={{
                                                            fontSize: '15px',
                                                            fontWeight: 700,
                                                            color: isDragging || fileList.length > 0 ? '#237804' : '#262626',
                                                            margin: '0 0 4px',
                                                            transition: 'color 0.25s ease',
                                                        }}>
                                                            Drag &amp; drop your file here
                                                        </p>
                                                        <p style={{ fontSize: '13px', color: '#8c8c8c', margin: '4px 0 12px' }}>
                                                            or click to <span style={{ color: PRIMARY, fontWeight: 600 }}>browse</span>
                                                        </p>
                                                        <p style={{ fontSize: '12px', color: '#bfbfbf', margin: 0 }}>
                                                            Only .xlsx (Excel) files are allowed
                                                        </p>
                                                    </Upload.Dragger>
                                                </div>
                                            </Form.Item>
                                            {fileList.length > 0 && (
                                                <Flex
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                    className="px-3 py-2 mb-3"
                                                    style={{
                                                        backgroundColor: '#ffffff',
                                                        borderRadius: '10px',
                                                        border: `1.5px solid ${PRIMARY_BORDER}`,
                                                    }}
                                                >
                                                    <Flex alignItems="center" style={{ gap: '10px' }}>
                                                        <FileExcelOutlined style={{ fontSize: '24px', color: PRIMARY }} />
                                                        <div>
                                                            <div style={{ fontWeight: 600, fontSize: '13px', color: '#262626' }}>
                                                                {fileList[0].name}
                                                            </div>
                                                            <Flex alignItems="center" style={{ gap: '6px', marginTop: '2px' }}>
                                                                {fileList[0].size && (
                                                                    <span className="text-muted" style={{ fontSize: '12px' }}>
                                                                        {(fileList[0].size / 1024).toFixed(1)} KB
                                                                    </span>
                                                                )}
                                                            </Flex>
                                                        </div>
                                                    </Flex>
                                                    <Button
                                                        type="text"
                                                        danger
                                                        icon={<DeleteOutlined />}
                                                        size="small"
                                                        className="d-inline-flex align-items-center justify-content-center"
                                                        onClick={() => {
                                                            setFileList([]);
                                                            setImportedData([]);
                                                        }}
                                                    />
                                                </Flex>
                                            )}
                                            {stats && (
                                                <>
                                                    <div style={{ fontWeight: 600, fontSize: '14px', color: '#262626', marginBottom: '12px' }}>
                                                        File Summary
                                                    </div>
                                                    <Row gutter={10} className="mb-3">
                                                        {[
                                                            {
                                                                title: 'Total Records',
                                                                value: stats.total,
                                                                valueColor: PRIMARY,
                                                                bgColor: ALERTBG,
                                                                icon: <Users size={14} style={{ color: PRIMARY }} />
                                                            },
                                                            {
                                                                title: 'Duplicate Numbers',
                                                                value: stats.duplicateNumbers,
                                                                valueColor: stats.duplicateNumbers > 0 ? '#ff4d4f' : '#fa8c16',
                                                                bgColor: '#fff7e6',
                                                                icon: <PhoneOutlined style={{ fontSize: '14px', color: '#fa8c16' }} />
                                                            },
                                                            {
                                                                title: 'Duplicate Emails',
                                                                value: stats.duplicateEmails,
                                                                valueColor: stats.duplicateEmails > 0 ? '#ff4d4f' : '#1890ff',
                                                                bgColor: '#e6f7ff',
                                                                icon: <MailOutlined style={{ fontSize: '14px', color: '#1890ff' }} />
                                                            }
                                                        ].map((item, index) => (
                                                            <Col span={8} key={index}>
                                                                <Flex alignItems="center" style={{ backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #f0f0f0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', gap: '6px', padding: '10px' }}>
                                                                    <div style={{ width: '30px', height: '30px', borderRadius: '6px', backgroundColor: item.bgColor, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                        {item.icon}
                                                                    </div>
                                                                    <div style={{ minWidth: 0, overflow: 'hidden' }}>
                                                                        <div style={{ fontSize: '18px', fontWeight: 700, color: item.valueColor, lineHeight: 1 }}>{item.value}</div>
                                                                        <div style={{ fontSize: '10px', color: '#8c8c8c', marginTop: '2px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }} title={item.title}>
                                                                            {item.title}
                                                                        </div>
                                                                    </div>
                                                                </Flex>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </>
                                            )}
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                icon={<UploadOutlined />}
                                                block
                                                style={{
                                                    backgroundColor: PRIMARY,
                                                    borderColor: PRIMARY,
                                                    borderRadius: '8px',
                                                    fontWeight: 600,
                                                    height: '44px',
                                                    fontSize: '15px',
                                                    marginTop: '8px'
                                                }}
                                            >
                                                Upload Contacts
                                            </Button>
                                            <div className="text-center mt-2" style={{ fontSize: '12px', color: '#8c8c8c' }}>
                                                <LockOutlined style={{ marginRight: '4px' }} />
                                                Your data is secure and will not be shared.
                                            </div>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <CustomAlertBanner
                                                className="mb-0"
                                                icon={<FileExcelOutlined style={{ fontSize: '24px' }} />}
                                                title="Supported Format"
                                                subtitle="Excel (.xlsx)"
                                            />
                                            <div className="mt-2 mb-3 px-1">
                                                <Flex alignItems="center" className="mb-2" style={{ gap: '8px' }}>
                                                    <CheckCircleFilled style={{ color: PRIMARY, fontSize: '14px' }} />
                                                    <span style={{ fontSize: '13px', color: '#595959' }}>Max file size: 10 MB</span>
                                                </Flex>
                                                <Flex alignItems="center" style={{ gap: '8px' }}>
                                                    <CheckCircleFilled style={{ color: PRIMARY, fontSize: '14px' }} />
                                                    <span style={{ fontSize: '13px', color: '#595959' }}>UTF-8 encoding recommended</span>
                                                </Flex>
                                            </div>
                                            <Button
                                                block
                                                onClick={downloadSampleExcel}
                                                icon={<DownloadOutlined />}
                                                className="d-inline-flex align-items-center justify-content-center mb-3"
                                                style={{ borderRadius: '8px', color: PRIMARY, borderColor: PRIMARY_BORDER, fontWeight: 500, height: '38px' }}
                                            >
                                                Download Sample File
                                            </Button>
                                            <div className="p-3" style={{
                                                backgroundColor: '#e6f7ff',
                                                border: '1px solid #91d5ff',
                                                borderRadius: '12px'
                                            }}>
                                                <Flex alignItems="flex-start" style={{ gap: '10px' }}>
                                                    <InfoCircleOutlined style={{ fontSize: '18px', color: '#1890ff', marginTop: '2px', flexShrink: 0 }} />
                                                    <div>
                                                        <div style={{ fontWeight: 600, fontSize: '13px', color: '#0050b3', marginBottom: '4px' }}>Need help?</div>
                                                        <div style={{ fontSize: '12px', color: '#595959', marginBottom: '8px' }}>Make sure your file contains valid contact information.</div>
                                                        <span style={{ fontSize: '12px', color: '#1890ff', fontWeight: 500, cursor: 'pointer' }}>Learn more →</span>
                                                    </div>
                                                </Flex>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card>
                        </Col>


                        <Col xs={24} sm={24} md={24} lg={24}>
                            <Card title={`New Contact`}>
                                <Row>
                                    <Col span={24}>
                                        <Form
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 10 }}
                                            layout="horizontal"
                                            ref={addContactRef}
                                            onFinish={HandleSubmit}
                                        >
                                            <Form.Item
                                                label=" Name"
                                                name=" Name"
                                                className=" my-3"
                                                rules={[{ message: 'Please enter your name!' }]}
                                            >
                                                <Input type="text"
                                                    value={contactName}
                                                    onChange={(e) => setContactName(e.target.value)}
                                                    placeholder=" Name"
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Mobile Number"
                                                name="Mobile Number"
                                                className=" my-3"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter  Mobile Number!',
                                                    },
                                                ]}>
                                                <Input type="text"
                                                    value={number}
                                                    onChange={(e) => setNumber(e.target.value)}
                                                    placeholder="Mobile Number"
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label=" Email ID"
                                                name=" Email ID"
                                                className=" my-3"
                                                rules={[
                                                    {
                                                        message: 'Please enter campaign name!',
                                                    },
                                                ]}>
                                                <Input type="text"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    placeholder="Email ID"
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label="Location"
                                                name="Location"
                                                className=" my-3"
                                                rules={[
                                                    {
                                                        message: 'Please enter campaign name!',
                                                    },
                                                ]}>
                                                <Input type="text"
                                                    value={location}
                                                    onChange={(e) => setLocation(e.target.value)}
                                                    placeholder="Location"
                                                />
                                            </Form.Item>
                                            <Form.Item label=" " className=" my-3">
                                                <Button type="primary" htmlType='submit'>Submit</Button>
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                    </Row>
                </Col>


            </Row>
        </>
    )
}

export default ContactList
